import Button from "@/components/inputs/button";
import Rodape from "@/features/Rodape";
import Image from "next/image";
import styled from "styled-components";
import Events from "@/utils/Events";
import themes from "@/styles/themes";

const Divisor = styled.div`
width: 328px;
height: 0;
margin: 16px 0.3px 0 0;
border: solid 1px ${themes.estadao};
`
const TextEsgotada = styled.p`
font-size: 18px;
color: ${themes.estadao};
text-align: center;
margin-top: -5px;
line-height: 1.4;
a {
color: ${themes.estadao};
font-weight:600;
text-decoration: underline;
}
`
const DivEsgotada = styled.div`
width: 340px;
display:flex;
justify-content: center;
align-items: center;
flex-direction: column;
`
const OfertaEsgotadaText = styled.h1`
color: ${themes.estadao};
font-weight: 700;
font-style: italic;
font-size: 42px;
text-align: center;
`
const MarginImage = styled.div`
margin-top: 36px;
`
const DivButton = styled.div`
width: 100%
`
const LogoDiv = styled.div`
padding: 15px;
text-align: center
`
export default function OfertaEsgotada() {
    const events = new Events();
    if (typeof window != "undefined") {
        window.setTimeout(function(){ events.trigger("pagina_oferta_esgotada_visualizado", {show: true}) },1000);
        }
    return (
        <DivEsgotada>
            <div>
            <LogoDiv>
                 <Image src={'/imgs/logo-estadao.svg'} alt={'Logo Estadão'} width={118} height={30}></Image>
            </LogoDiv>
            <Divisor/>
            </div>
            <MarginImage>
                <Image src={'/imgs/news_img.webp'} alt="news icon" width={180} height={200}></Image>
            </MarginImage>
            <OfertaEsgotadaText>Opa! Oferta esgotada</OfertaEsgotadaText>
            <TextEsgotada>Essa oferta atingiu o limite máximo de vendas e não está mais disponível. <br/>
            Entre em contato com a nossa Central de Vendas por telefone ou WhatsApp. <br/>
            <a  onClick={()=> events.trigger("pagina_oferta_esgotada_televendas_telefone", {show:true})} href="tel:0800 770 2166">0800 770 2166</a> <br/>
            Falar com atendente via <a onClick={()=> events.trigger("pagina_oferta_esgotada_televendas_whatsapp", {show:true})} target="_blank" href="https://api.whatsapp.com/send?phone=5511992482333&text&source&data"> WhatsApp</a></TextEsgotada>
            <DivButton onClick={()=>events.trigger("pagina_oferta_esgotada_ofertas", {show:true})}>
                <a target="_blank" href="https://ofertas.estadao.com.br/"><Button style={{background:'#329e2d'}}>CONFIRA OUTRAS OFERTAS!</Button></a>
            </DivButton>
            <Rodape/>
        </DivEsgotada>
    );
}
